<template>

	<div class="headline">
		<h3><slot name="subHeadline" /></h3>
		<h2 v-if="$slots.headline"><slot name="headline" /></h2>
		<p><slot name="content" /></p>
	</div>

</template>

<script>

	export default {
		name: "SectionHeadline"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "container.scss";
	@import "responsive-font.scss";

	.headline {
		@include container;
		margin:0;
		@include media(xxlarge) {
			max-width:80vw;
		}
	}
	.centered {
		text-align:center; margin:0 auto;
		@include media(small, large) {
			text-align:left;
		}
		h2, h3, p {
			margin-left:auto; margin-right:auto;
		}
	}
	h2, h3 {
		text-transform:uppercase; font-weight:400;
	}
	h3 {
		@include responsive-font(20);
		line-height:1.33; color:#FDB913; text-transform:uppercase; margin-bottom:.8rem;
	}
	h2 {
		@include responsive-font(40);
		line-height:1.25; color:#3D3D3D; margin-bottom:2.8vw;
		@include media(small, large) {
			@include responsive-font(35);
		}
		// max-width:70rem;
	}
	p {
		color:#6D6E71; max-width:94rem; margin:0;
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/SectionHeadline.vue